import React from "react";
import Moment from "moment";
/*
    Importing React Scroll for animating scrolling down to elements
*/
import { animateScroll as scroll } from 'react-scroll';
/*
    Importing NextStepButton that is a component that updates the page in Redux
*/
import NextFinanceButton from "../../partials/NextFinanceButton";
/*
    This page is using a template VerifyLayout
    TODO: May change this to one StepLayout
*/
import AccountLayout from '../../../containers/AccountLayout';
/*
    For Redux, importing connect and action
    Redux connect is to access Redux states
    Redux actions to update the Redux states
*/
import { connect } from "react-redux";
import { updateForm, setStep, setInfo, setFinance, setLatest, setCurrent } from "../../../store/actions/FormAction";
/*
    Using Validation functions from utils folder
*/
import Validation from '../../../utils/Validation';
const validation = new Validation();
/*
    EmploymentInfo view that displays the Employment Info page
    Remember JSX requires you to use camelcasing of attributes
    (ie className vs 'class', htmlFor vs 'for', tabIndex vs tab-index)
    Remember JSX requires all tags be closed (ie: self closed <hr />, <br />)
    Create React App requires alt tags for all <img> elements (good for SEO too)
*/
class EmploymentInfo extends React.Component {

  constructor(){
    super();

    this.employmentchecked = false;

    this.employedchecked = false;
    this.cochecked = false;
    this.cophnchecked = false;
    this.rolechecked = false;
    this.employerdetailschecked = false;

    this.depositdetailschecked = false;
    this.paymentdetailschecked = false;
    this.benefitdetailschecked = false;
    this.selfdetailschecked = false;

    this.employmentdetailschecked = false;

    this.handleEmploymentChange = this.handleEmploymentChange.bind(this);
    this.handlePaymentChange = this.handlePaymentChange.bind(this);
    this.handleBenefitChange = this.handleBenefitChange.bind(this);
    this.handleCoChange = this.handleCoChange.bind(this);
    this.handlePhoneChange = this.handlePhoneChange.bind(this);

    this.lastpayday = '';
    this.nextpayday = '';
    this.weekendCheck = this.weekendCheck.bind(this);
    this.calcMonthPaydates = this.calcMonthPaydates.bind(this);
  }

  componentDidMount() {
    this.props.updateForm("pagename", "Income Information");
    this.props.lateststep < 5 && this.props.setLatest(5);
    this.props.setCurrent(5);
    this.props.setStep(1);
    this.props.setInfo(3);
    this.props.setFinance(0);

    if (this.props.incomesource.length > 0){
      this.employmentchecked = true;
      let querydataanswer = "[data-answer='"+this.props.incomesource+"']";
      document.querySelectorAll(querydataanswer)[0].classList.add('picked');
      if (this.props.paymenttype.length > 0 && this.props.incomesource !== "Unemployed"){
        this.props.updateForm("paytypefilled", true);
        this.props.updateForm("paytypeold", this.props.paymenttype);
        let queryclass = "."+this.props.incomesource.toLowerCase().replace(" ", "")+" ";
        querydataanswer = queryclass+"[data-answer='"+this.props.paymenttype+"']";
        document.querySelectorAll(querydataanswer)[0].classList.add('picked');
      }
      if (this.props.incomesource === "Employed"){
        document.getElementById("employed").classList.remove("hidden");
        if (this.props.paymenttype.length > 0){
          this.depositdetailschecked = true;
          document.getElementById("employed2").classList.remove("hidden");
          if (this.props.co.length > 2){
            this.cochecked = true;
            document.getElementById("co").classList.add('filled');
            document.querySelector("label[for='co']").classList.add('activeaddy');
          }
          if (this.props.cophn.length >= 12){
            this.cophnchecked = true;
            document.getElementById("phn").classList.add('filled');
            document.querySelector("label[for='phn']").classList.add('activeaddy');
          }
          if (this.props.co.length > 2 && this.props.cophn.length >= 12){
            this.employmentdetailschecked = true;
          }
        }
      } else if (this.props.incomesource === "Benefits"){
        document.getElementById("benefits").classList.remove("hidden");
        if (this.props.paymenttype.length > 0){
          this.paymentdetailschecked = true;
          document.getElementById("benefits2").classList.remove("hidden");
          if (this.props.benefittype.length > 0){
            this.benefitdetailschecked = true;
            this.employmentdetailschecked = true;
            querydataanswer = "[data-answer='"+this.props.benefittype+"']";
            document.querySelectorAll(querydataanswer)[0].classList.add('picked');
          }
        }
      } else if (this.props.incomesource === "Self Employed"){
        document.getElementById("selfemployed").classList.remove("hidden");
        if (this.props.paymenttype.length > 0){
          this.selfdetailschecked = true;
          this.employmentdetailschecked = true;
        }
      } else {
        this.employmentdetailschecked = true;
      }
    }
  }

  handleEmploymentChange(e) {
    e.preventDefault();

    [].forEach.call( document.querySelectorAll('.employmentbutton'), function(el) {
      el.classList.remove("picked");
    });

    let incomesource = e.target.dataset.answer;
    if (e.target.classList.contains('employmentbutton')){
      e.target.classList.add("picked");
    } else if (e.target.parentNode.classList.contains('employmentbutton')){
      incomesource = e.target.parentNode.dataset.answer;
      e.target.parentNode.classList.add("picked");
    } else if (e.target.parentNode.parentNode.classList.contains('employmentbutton')){
      incomesource = e.target.parentNode.parentNode.dataset.answer;
      e.target.parentNode.parentNode.classList.add("picked");
    }
    this.props.updateForm("incomesource", incomesource);

    let employdetails = document.getElementById("employed");
    let benefitdetails = document.getElementById("benefits");
    let selfemploydetails = document.getElementById("selfemployed");

    this.employmentdetailschecked = false;
    if (incomesource === "Employed"){
      employdetails.classList.remove("hidden");
      if (window.pageYOffset < 250)
        scroll.scrollTo(250, {duration: 1000});
      benefitdetails.classList.add("hidden");
      selfemploydetails.classList.add("hidden");
      if (this.depositdetailschecked && this.employerdetailschecked)
        this.employmentdetailschecked = true;
    } else if (incomesource === "Benefits"){
      benefitdetails.classList.remove("hidden");
      if (window.pageYOffset < 250)
        scroll.scrollTo(250, {duration: 1000});
      employdetails.classList.add("hidden");
      selfemploydetails.classList.add("hidden");
      if (this.paymentdetailschecked && this.benefitdetailschecked)
        this.employmentdetailschecked = true;
    } else if (incomesource === "Self Employed"){
      selfemploydetails.classList.remove("hidden");
      if (window.pageYOffset < 250)
        scroll.scrollTo(250, {duration: 1000});
      employdetails.classList.add("hidden");
      benefitdetails.classList.add("hidden");
      if (this.selfdetailschecked)
        this.employmentdetailschecked = true;
    } else {
      benefitdetails.classList.add("hidden");
      employdetails.classList.add("hidden");
      selfemploydetails.classList.add("hidden");
      this.employmentdetailschecked = true;
    }
    this.employmentchecked = true;
  }
  weekendCheck(checkdate, paytype){

    //weekend check
    let testday = Moment(checkdate).day();

    let momentpay1 = Moment(checkdate).subtract(2, 'days').format('MM/DD/YYYY');
    let momentpay2 = Moment(checkdate).subtract(1, 'days').format('MM/DD/YYYY');
    let momentcheck1 = Moment(checkdate).add(1, 'days').format('MM/DD/YYYY');
    let momentcheck2 = Moment(checkdate).add(2, 'days').format('MM/DD/YYYY');

    if (testday === 0 || testday === 6){
      // show before / after options for holidays and weekends?
      if (testday  === 0){
        if (paytype === "Check"){
          checkdate = momentcheck1;
        } else {
          checkdate = momentpay1;
        }
      } else if (testday === 6){
        if (paytype === "Check"){
          checkdate = momentcheck2;
        } else {
          checkdate = momentpay2;
        }
      }
    }
    return checkdate;
  }

  calcMonthPaydates(payday, payday2=""){

    let today = new Date();
    today.setHours(0, 0, 0, 0);
    let payyear = today.getFullYear();
    let theday = today.getDate();
    let themonth = today.getMonth();
    let paymonth = parseInt(themonth, 10) + 1;
    if (paymonth < 10){
      paymonth = "0" + paymonth;
    }
    let lastmonth = themonth;
    if (lastmonth < 1){
      lastmonth = 12;
    }
    let nextmonth = themonth + 2;
    if (nextmonth > 12){
      nextmonth = 1;
    }

    if (payday === 30 || payday === 31 || payday === "Last"){
      if (themonth === 0 || themonth === 2 || themonth === 4 || themonth === 6 || themonth === 7 || themonth === 9 || themonth === 11){
        payday = 31;
      } else if (themonth === 1){
        payday = 28;
      } else {
        payday = 30;
      }
    }

    if (payday2 > 0){
      this.lastpayday = lastmonth+"/"+payday2+"/"+payyear;
      this.nextpayday = paymonth+"/"+payday+"/"+payyear;
      if (payday <= theday && theday < parseInt(payday2, 10)){
        this.lastpayday = paymonth+"/"+payday+"/"+payyear;
        this.nextpayday = paymonth+"/"+payday2+"/"+payyear;
      } else if (payday < theday && parseInt(payday2, 10) < theday){
        this.lastpayday = paymonth+"/"+payday2+"/"+payyear;
        this.nextpayday = nextmonth+"/"+payday+"/"+payyear;
      }
    } else {
      this.lastpayday = paymonth+"/"+payday+"/"+payyear;
      this.nextpayday = nextmonth+"/"+payday+"/"+payyear;
      if (theday < parseInt(payday,10)){
        this.lastpayday = lastmonth+"/"+payday+"/"+payyear;
        this.nextpayday = paymonth+"/"+payday+"/"+payyear;
      }
    }

  }

  handlePaymentChange(e){
    e.preventDefault();

    [].forEach.call( document.querySelectorAll('.paybutton'), function(el) {
      el.classList.remove("picked");
    });

    this.depositdetailschecked = false;
    this.paymentdetailschecked = false;

    let payment = "";
    let category = "";
    if (e.target.classList.contains('paybutton')){
      payment = e.target.dataset.answer;
      category = e.target.dataset.category;
      e.target.classList.add("picked");
    } else if (e.target.parentNode.classList.contains('paybutton')){
      payment = e.target.parentNode.dataset.answer;
      category = e.target.parentNode.dataset.category;
      e.target.parentNode.classList.add("picked");
    } else if (e.target.parentNode.parentNode.classList.contains('paybutton')){
      payment = e.target.parentNode.parentNode.dataset.answer;
      category = e.target.parentNode.parentNode.dataset.category;
      e.target.parentNode.parentNode.classList.add("picked");
    }

    this.props.updateForm("paymenttype", payment);

    // In case the user goes back to this page and changes the payment type - may need to update the pay dates (weekends)
    // Paper Check goes weekday after - other pay types are the weekday before
    if (this.props.paytypefilled && this.props.paytypeold !== payment){
      if (this.props.payfrequency.length > 0){
        if (this.props.payfrequency === "Semi-Monthly" || this.props.payfrequency === "Monthly"){
          if (this.props.payfrequency === "Monthly" && this.props.payday > 0){
            this.calcMonthPaydates(this.props.payday);
            this.lastpayday = this.weekendCheck(this.lastpayday, payment);
            this.nextpayday = this.weekendCheck(this.nextpayday, payment);
            this.props.updateForm("lastpay", this.lastpayday);
            this.props.updateForm("nextpay", this.nextpayday);
          } else if (this.props.payfrequency === "Semi-Monthly" && this.props.payday > 0 && this.props.payday2 > 0){
            this.calcMonthPaydates(this.props.payday, this.props.payday2);
            this.lastpayday = this.weekendCheck(this.lastpayday, payment);
            this.nextpayday = this.weekendCheck(this.nextpayday, payment);
            this.props.updateForm("lastpay", this.lastpayday);
            this.props.updateForm("nextpay", this.nextpayday);
          }
        }
      }
    }

    if (category === 'employed'){
      this.depositdetailschecked = true;
      document.getElementById("employed2").classList.remove("hidden");
      document.getElementById("co").focus();
      if (window.pageYOffset < 550)
        scroll.scrollTo(550, {duration: 1100});
      if (validation.checkAll([true,this.depositdetailschecked,this.cochecked,this.cophnchecked])){
        this.employmentdetailschecked = true;
        if (window.pageYOffset < 700)
          scroll.scrollTo(700, {duration: 1200});
      }
    } else if (category === 'selfemployed'){
      this.selfdetailschecked = true;
      this.employmentdetailschecked = true;
      if (window.pageYOffset < 350)
        scroll.scrollTo(350, {duration: 800});
    } else {
      this.paymentdetailschecked = true;
      document.getElementById("benefits2").classList.remove("hidden");
      if (window.pageYOffset < 600)
        scroll.scrollTo(600, {duration: 1200});
      if (validation.checkAll([true,this.benefitdetailschecked])){
        this.employmentdetailschecked = true;
        if (window.pageYOffset < 800)
          scroll.scrollTo(800, {duration: 1400});
      }
    }
  }

  handleBenefitChange(e) {
    e.preventDefault();

    [].forEach.call( document.querySelectorAll('.benefitbutton'), function(el) {
      el.classList.remove("picked");
    });

    let benefit = "";
    if (e.target.classList.contains('benefitbutton')){
      e.target.classList.add("picked");
      benefit = e.target.dataset.answer;
    } else {
      e.target.parentNode.classList.add("picked");
      benefit = e.target.parentNode.dataset.answer;
    }
    this.benefitdetailschecked = true;

    this.props.updateForm("benefittype", benefit);

    if (validation.checkAll([true,this.paymentdetailschecked])){
      this.employmentdetailschecked = true;
      if (window.pageYOffset < 800)
        scroll.scrollTo(800, {duration: 1000});
    }
  }

  handleCoChange(e) {
    let co = e.target.value;
    this.props.updateForm("co", co);

    const cotip = document.getElementById("cotip");
    const colabel = document.querySelector("label[for='co']");

    if (co.length > 2){
      cotip.classList.add("hidden");
      cotip.innerHTML = "";
      this.cochecked = true;
      colabel.classList.add("activeaddy");
    } else {
      colabel.classList.remove("activeaddy");
    }

    if (validation.checkAll([true,this.depositdetailschecked,this.cochecked,this.cophnchecked])){
      this.employmentdetailschecked = true;
    }
  }
  handleCoBlur(e) {
    let co = e.target.value;
    let cotip = document.getElementById("cotip");

    if (co.length > 0){
      if (co.length < 2){
        cotip.classList.remove("hidden");
        cotip.innerHTML = "Please enter your full company name";
      } else {
        if (window.pageYOffset < 600)
          scroll.scrollTo(600, {duration: 1000});
      }
    } else {
      e.target.classList.remove('filled');
      cotip.classList.remove("hidden");
      cotip.innerHTML = "Please enter your company name.";
    }
  }

  handleCoFocus(e) {
    e.target.classList.add('filled');
  }

  handlePhoneChange(e) {
    let phn = e.target.value;
    const phntip = document.getElementById("phntip");

    phn = phn.replace(/\D/g, '');
    if (phn.length === 0){
      phntip.classList.remove("hidden");
      phntip.innerHTML = "Please enter numbers only";
    } else {
      phntip.classList.add("hidden");
      phntip.innerHTML = "";
    }

    let split = 3;
    let chunk = [];
    for (let i = 0; i < phn.length; i += split) {
      split = (i <= 3) ? 3 : 4;
      chunk.push( phn.substr( i, split ) );
    }
    if (chunk[0]) chunk[0] = validation.checkPhoneNum(chunk[0], 200);
    let tmp = chunk.join("-");
    this.props.updateForm("cophn", tmp);

    const phnlabel = document.querySelector("label[for='phn']");
    if (validation.validatePhone(phn)){
      phntip.classList.add("hidden");
      phntip.innerHTML = "";

      this.cophnchecked = true;
      phnlabel.classList.add("activeaddy");
      if (window.pageYOffset < 650)
        scroll.scrollTo(650, {duration: 1000});
    } else {
      phnlabel.classList.remove("activeaddy");
    }
    if (validation.checkAll([true,this.depositdetailschecked,this.cochecked,this.cophnchecked])){
      this.employmentdetailschecked = true;
    }
  }

  handlePhoneBlur(e) {
    let phn = e.target.value;
    let phntip = document.getElementById("phntip");

    if (phn.length > 0){
      if (!validation.validatePhone(phn)){
        phntip.classList.remove("hidden");
        phntip.innerHTML = "Please enter a valid company number.";
      }
    } else {
      e.target.classList.remove('filled');
      phntip.classList.remove("hidden");
      phntip.innerHTML = "Please enter your company number.";
    }
  }

  handlePhoneFocus(e) {
    e.target.classList.add('filled');
  }

  render() {

    const nextFinance = 0;
    const nextLink = "/payschedule";
    const btnText = "Continue";
    const btnClasses = "btn next-step";

      return (
        <AccountLayout>
          <div className="container" id="stepper-step-3">
            <div className="text-center topcopy">
                <h1>What&#39;s your main source of income?</h1>
            </div>

            <hr />

            <form className="flowform">
              <input type="hidden" value="needed for disabling autocomplete" />
              <div id="employmentbuttons">
                  <div className="button-group">
                      <a className="btn mutedstrip-radio employmentbutton" data-answer="Employed" onClick={this.handleEmploymentChange} tabIndex="3">
                        <div></div><span>I&#39;m employed</span>
                      </a>
                      <a className="btn mutedstrip-radio employmentbutton" data-answer="Benefits" onClick={this.handleEmploymentChange} tabIndex="4">
                        <div></div><span>I receive benefits</span>
                      </a>
                      <a className="btn mutedstrip-radio employmentbutton" data-answer="Self Employed" onClick={this.handleEmploymentChange} tabIndex="5">
                        <div></div><span>I&#39;m self employed</span>
                      </a>
                      <a className="btn mutedstrip-radio employmentbutton" data-answer="Unemployed" onClick={this.handleEmploymentChange} tabIndex="6">
                        <div></div><span>I&#39;m not receiving any income</span>
                      </a>
                  </div>
              </div>

              <div id="selfemployed" className="hidden">
                  <p className="buttontitle">How do you receive your income?</p>
                  <div className="selfemployed button-group">
                    <a className="btn mutedstrip-radio paybutton" data-answer="Direct Deposit" data-category="selfemployed" onClick={this.handlePaymentChange} tabIndex="5">
                      <div></div><span>Direct Deposit</span>
                    </a>
                    <a className="btn mutedstrip-radio paybutton" data-answer="Cash" data-category="selfemployed" onClick={this.handlePaymentChange} tabIndex="6">
                      <div></div><span>Cash</span>
                    </a>
                    <a className="btn mutedstrip-radio paybutton" data-answer="Check" data-category="selfemployed" onClick={this.handlePaymentChange} tabIndex="7">
                      <div></div><span>Paper Check</span>
                    </a>
                  </div>
              </div>

              <div id="employed" className="hidden">
                  <p className="buttontitle">How do you get paid?</p>
                  <div className="employed button-group">
                    <a className="btn mutedstrip-radio paybutton" data-answer="Direct Deposit" data-category="employed" onClick={this.handlePaymentChange} tabIndex="5">
                      <div></div><span>Direct Deposit</span>
                    </a>
                    <a className="btn mutedstrip-radio paybutton" data-answer="Cash" data-category="employed" onClick={this.handlePaymentChange} tabIndex="6">
                      <div></div><span>Cash</span>
                    </a>
                    <a className="btn mutedstrip-radio paybutton" data-answer="Check" data-category="employed" onClick={this.handlePaymentChange} tabIndex="7">
                      <div></div><span>Paper Check</span>
                    </a>
                  </div>
                  <div id="employed2" className="hidden padtop">
                    <div className="form-group">

                      <label>Where do you work?</label>
                      <label htmlFor="co">
                        <div className="errortip hidden" id="cotip">
                            Please provide your company name.
                        </div>
                        <input type="text" id="co" name="co" autoComplete="co" className="form-control" value={this.props.co} onChange={this.handleCoChange} onBlur={this.handleCoBlur} onFocus={this.handleCoFocus} tabIndex="8"/>
                        <span className="floating-label">Company Name</span>
                      </label>
                      <label htmlFor="phn" className="ptop">
                        <div className="errortip hidden" id="phntip">
                            Please provide a valid phone number.
                        </div>
                        <input type="tel" id="phn" name="phn" autoComplete="phn" className="form-control" value={this.props.cophn} onChange={this.handlePhoneChange} onBlur={this.handlePhoneBlur} onFocus={this.handlePhoneFocus} tabIndex="9" maxLength="12"/>
                        <span className="floating-label">Company Phone</span>
                      </label>
                    </div>
                  </div>
              </div>

              <div id="benefits" className="hidden">
                  <p className="buttontitle">How do you receive your income?</p>
                  <div className="benefits button-group">
                    <a className="btn mutedstrip-radio paybutton" data-answer="Direct Deposit" data-category="benefits" onClick={this.handlePaymentChange} tabIndex="5">
                      <div></div><span>Direct Deposit</span>
                    </a>
                    <a className="btn mutedstrip-radio paybutton" data-answer="Cash" data-category="benefits" onClick={this.handlePaymentChange} tabIndex="6">
                      <div></div><span>Cash</span>
                    </a>
                    <a className="btn mutedstrip-radio paybutton" data-answer="Check" data-category="benefits" onClick={this.handlePaymentChange} tabIndex="7">
                      <div></div><span>Paper Check</span>
                    </a>
                  </div>
                  <div id="benefits2" className="benefits2 padtop hidden" >
                    <p className="buttontitle">What type of benefits do you receive?</p>
                    <div className="button-group">
                      <a className="btn mutedstrip-radio benefitbutton" data-answer="Social Security" onClick={this.handleBenefitChange} tabIndex="8">
                        <div></div><span>Social Security</span>
                      </a>
                      <a className="btn mutedstrip-radio benefitbutton" data-answer="Pension" onClick={this.handleBenefitChange} tabIndex="9">
                        <div></div><span>Pension</span>
                      </a>
                      <a className="btn mutedstrip-radio benefitbutton" data-answer="Disability" onClick={this.handleBenefitChange} tabIndex="10">
                        <div></div><span>Disability</span>
                      </a>
                    </div>
                  </div>
              </div>

              <div id="allemployedbtn">
                <NextFinanceButton next={nextLink} btnText={btnText} btnClasses={btnClasses} disableNext={!this.employmentdetailschecked} hideNext={!this.employmentchecked} financestep={nextFinance} tabIndex="7"/>
              </div>
            </form>
          </div>
        </AccountLayout>
        );
    }
}

const mapStateToProps = (state) => ({
    incomesource: state.FormReducer.incomesource,
    paymenttype: state.FormReducer.paymenttype,
    payfrequency: state.FormReducer.payfrequency,
    payday: state.FormReducer.payday,
    payday2: state.FormReducer.payday2,
    paytypefilled: state.FormReducer.paytypefilled,
    paytypeold: state.FormReducer.paytypeold,
    benefittype: state.FormReducer.benefittype,
    co: state.FormReducer.co,
    cophn: state.FormReducer.cophn,
    jobtitle: state.FormReducer.jobtitle,
    lateststep: state.FormReducer.lateststep,
    currentstep: state.FormReducer.currentstep
});

const mapDispatchToProps = (dispatch) => ({
    updateForm: (stateType, value) => dispatch(updateForm(stateType, value)),
    setStep: (step) => dispatch(setStep(step)),
    setInfo: (infostep) => dispatch(setInfo(infostep)),
    setFinance: (financestep) => dispatch(setFinance(financestep)),
    setLatest: (lateststep) => dispatch(setLatest(lateststep)),
    setCurrent: (currentstep) => dispatch(setCurrent(currentstep))
});

export default connect(mapStateToProps, mapDispatchToProps)(EmploymentInfo)



// WEBPACK FOOTER //
// ./src/components/views/EmploymentInfo/index.js